var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 28,
    viewBox: "0 0 37 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9361 19.394C34.3803 16.0696 31.845 14.1787 28.1249 14.222C26.778 12.7727 24.338 9.1549 28.1249 2.63422C20.8045 7.16246 14.358 26.7645 28.8177 25.9729C32.3379 25.7802 35.4919 22.7183 34.9361 19.394Z",
    stroke: "#B39359",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3287 20.2696C16.3424 16.9098 14.1557 14.7107 10.4694 14.2705C9.38299 12.6623 8.42263 7.95686 13.2727 2C5.2659 5.52768 -5.27076 24.8868 9.16311 25.9813C12.677 26.2478 16.315 23.6293 16.3287 20.2696Z",
    stroke: "#B39359",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQote);
export default __webpack_public_path__ + "static/media/qote.61bfe072338a3c052ba5462d684d5589.svg";
export { ForwardRef as ReactComponent };